package com.pincer.client

import com.pincer.core.PincerException
import com.pincer.core.contracts.RequestContract
import com.pincer.core.contracts.PincerRequest
import com.pincer.core.contracts.PincerResponse
import kotlinx.coroutines.delay
import kotlinx.serialization.SerializationException

/*
NOTE: This class does not work yet in the JS output because the delay call is basically ignored
*/
open class RequestContractFromWebSocket(val webSocket: WebSocket): RequestContract {

    override suspend fun process(request: PincerRequest): PincerResponse {
        var response: PincerResponse? = null
        webSocket.registerListener(false) listen@{ string ->
            if (string.contains(request.id)) {
                try {
                    val candidate = PincerResponse.parse(string)
                    if (candidate.req == request.id) {
                        response = candidate
                        return@listen true
                    }
                }
                catch (ignored: SerializationException) { }
            }
            return@listen false
        }
        webSocket.message(request.json())
        var timeout: Long = 1000 * 5
        val step: Long = 100
        while (response == null) {
            if (timeout <= 0) throw PincerException("Timeout")
            timeout = timeout - step
            // Note, this doesn't work in the JS version
            delay(step)
        }
        return response
    }

}
